import { makeStyles, shorthands, tokens, typographyStyles, } from '@fluentui/react-components';

export const useHeaderControlStyles = makeStyles({
  title: { ...typographyStyles.body1Strong },
  required: {
    color: tokens.colorStatusDangerForeground1,
  },
  resetButton: {
    ...shorthands.border('none'),
    backgroundColor: 'transparent',
  },
  wrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignContent: 'center',
    ...shorthands.padding('10px', 0),
  },
  header: {
    marginBottom: '10px',
    '& .helpbutton ': {
      paddingLeft: '5px',
      display: 'inline-block',
    },
  },
});
